interface AdSlotProps {
  variant: 'leaderboard' | 'inline' | 'sticky'
}

function AdSlot({ variant }: AdSlotProps) {
  if (variant === 'leaderboard') {
    return (
      <div className="flex w-full justify-center border-b border-slate-800 bg-slate-950/60 py-2">
        <div className="flex h-[90px] w-full max-w-[728px] items-center justify-center rounded-md border border-dashed border-slate-800 text-xs uppercase tracking-widest text-slate-600">
          Ad Space · 728x90
        </div>
      </div>
    )
  }

  if (variant === 'inline') {
    return (
      <div className="mx-auto flex h-[250px] w-full max-w-[300px] items-center justify-center rounded-lg border border-dashed border-slate-800 bg-slate-900/40 text-xs uppercase tracking-widest text-slate-600">
        Ad Space · 300x250
      </div>
    )
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 hidden border-t border-slate-800 bg-slate-950/95 py-2 backdrop-blur sm:block">
      <div className="mx-auto flex h-[60px] max-w-3xl items-center justify-center rounded-md border border-dashed border-slate-800 text-xs uppercase tracking-widest text-slate-600">
        Ad Space · Sticky Bottom Banner
      </div>
    </div>
  )
}

export default AdSlot
